import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LockUnlockService {

  constructor(private http: HttpClient) { }

  lockUnlock(baseUrl: string, params: any): Observable<any> {
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/saveJsonObject?action_code=kzksix`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }
}
